/**
 * CC Luxury Extensions - Variant Color Swatches & Category Filter
 * v11 - Fixed: clicks work on ALL pills, not just first one
 */
(function() {
  'use strict';

  /* =============================================
   * COLOR CODE -> ASSET FILENAME MAPPING (foto-2)
   * ============================================= */
  var COLOR_ASSETS = {
    'A3': 'asch-braun---a3---foto-2.webp',
    '1B': 'asch-dunkelbraun---1b---foto-2.webp',
    'A2': 'asch-dunkelbraun---a2---foto-2.webp',
    'A5': 'asch-hellbraun---a5---foto-2.webp',
    'A4': 'asch-hellschokobraun---a4---foto-2.webp',
    'A6': 'asch-mittelbraun----a6---foto-2.webp',
    'A18': 'aschblond---a18---foto-2.webp',
    '1T-613': 'balayage---1t-613---foto-2.webp',
    '2T-8': 'balayage---2t-8---foto-2.webp',
    '2T-14': 'balayage---2t-14---foto-2.webp',
    '2T-613': 'balayage---2t-613---foto-2.webp',
    '2T-Silver': 'balayage---2t-silver---foto-2.webp',
    '2T18': 'balayage---2t18---foto-2.webp',
    '3T-613': 'balayage---3t-613---foto-2.webp',
    '4T-613': 'balayage---4t-613---foto-2.webp',
    '5T-18': 'balayage---5t-18---foto-2.webp',
    '5T-613': 'balayage---5t-613---foto-2.png',
    '5T-Silver': 'balayage---5t-silver---foto-2.webp',
    'Bergen Blond': 'balayage---bergen-blond---foto-2.webp',
    'Natural-Grey': 'balayage---natural-grey---foto-2.webp',
    'Norwegiant-613': 'balayage---norwegiant-613---foto-2.webp',
    'Silver': 'beigeblond---silver---foto-2.webp',
    'A530': 'burgund---a530---foto-2.webp',
    'A24': 'champagnerblond---a24---foto-2.webp',
    'Nr.8': 'dunkel-honigbraun---nr.8---foto-2.webp',
    '2E': 'dunkelschokobraun---2e---foto-2.webp',
    '4-27T24': 'gestraehnt---4-27t24---foto-2.webp',
    '5P-18A': 'gestraehnt---5p-18a---foto-2.webp',
    '5P-Silver': 'gestraehnt---5p-silver---foto-2.webp',
    'Blond Ombre': 'gestraehnt---blond-ombre---foto-2.webp',
    'Dubai': 'gestraehnt---dubai---foto-2.webp',
    'Mocha Melt': 'gestraehnt---mocha-melt---foto-2.webp',
    'Viking Blond': 'gestraehnt---viking-blond---foto-2.webp',
    'Grey': 'grey---grey---foto-2.webp',
    'A8': 'haselnussbraun---a8---foto-2.webp',
    'A14': 'hell-sandblond---a14---foto-2.webp',
    'Nr.4': 'hell-schokobraun---nr.4---foto-2.webp',
    'Nr.10': 'honigbraun---nr.10---foto-2.webp',
    'Caramelized': 'karamell---caramelized---foto-2.webp',
    'A33': 'kupfer---a33---foto-2.webp',
    'A30': 'kupferblond---a30---foto-2.webp',
    'A99J': 'mahagoni---a99j---foto-2.webp',
    'Nr. 6': 'mittelbraun---nr.6---foto-2.webp',
    'Norwegian': 'norwegianblond---norwegian---foto-2.webp',
    'Pearl White': 'pearl-white---pearl-white---foto-2.webp',
    '613': 'platinblond---613---foto-2.webp',
    'A12': 'sandblond---a12---foto-2.webp',
    'Nr. 2': 'schokobraun---nr.2---foto-2.webp',
    'A1': 'schwarz---a1---foto-2.webp',
    'Natural': 'schwarzbraun---natural---foto-2.webp'
  };

  var COLOR_NAMES = {
    'A3': 'Asch-Braun', '1B': 'Asch-Dunkelbraun', 'A2': 'Asch-Dunkelbraun',
    'A5': 'Asch-Hellbraun', 'A4': 'Asch-Hellschokobraun', 'A6': 'Asch-Mittelbraun',
    'A18': 'Aschblond', '1T-613': 'Balayage 1T-613', '2T-8': 'Balayage 2T-8',
    '2T-14': 'Balayage 2T-14', '2T-613': 'Balayage 2T-613', '2T-Silver': 'Balayage Silver',
    '2T18': 'Balayage 2T18', '3T-613': 'Balayage 3T-613', '4T-613': 'Balayage 4T-613',
    '5T-18': 'Balayage 5T-18', '5T-613': 'Balayage 5T-613', '5T-Silver': 'Balayage Silver',
    'Bergen Blond': 'Bergen Blond', 'Natural-Grey': 'Natural Grey',
    'Norwegiant-613': 'Norwegiant Blond', 'Silver': 'Beigeblond Silver',
    'A530': 'Burgund', 'A24': 'Champagnerblond', 'Nr.8': 'Dunkel-Honigbraun',
    '2E': 'Dunkelschokobraun', '4-27T24': 'Gestr\u00e4hnt 4-27T24',
    '5P-18A': 'Gestr\u00e4hnt 5P-18A', '5P-Silver': 'Gestr\u00e4hnt Silver',
    'Blond Ombre': 'Blond Ombr\u00e9', 'Dubai': 'Dubai', 'Mocha Melt': 'Mocha Melt',
    'Viking Blond': 'Viking Blond', 'Grey': 'Grey', 'A8': 'Haselnussbraun',
    'A14': 'Hell-Sandblond', 'Nr.4': 'Hell-Schokobraun', 'Nr.10': 'Honigbraun',
    'Caramelized': 'Karamell', 'A33': 'Kupfer', 'A30': 'Kupferblond',
    'A99J': 'Mahagoni', 'Nr. 6': 'Mittelbraun', 'Norwegian': 'Norwegianblond',
    'Pearl White': 'Pearl White', '613': 'Platinblond', 'A12': 'Sandblond',
    'Nr. 2': 'Schokobraun', 'A1': 'Schwarz', 'Natural': 'Schwarzbraun'
  };

  var COLOR_CATEGORIES = {
    'A1': 'schwarz', 'Natural': 'schwarz', '1B': 'schwarz', 'A2': 'schwarz',
    'Nr. 2': 'braun', '2E': 'braun', 'A3': 'braun', 'A4': 'braun',
    'Nr.4': 'braun', 'A5': 'braun', 'A6': 'braun', 'Nr. 6': 'braun',
    'Nr.8': 'braun', 'A8': 'braun', 'Nr.10': 'braun', 'Caramelized': 'braun',
    'A12': 'blond', 'A14': 'blond', 'A18': 'blond', 'A24': 'blond',
    'A30': 'blond', 'Norwegian': 'blond', '613': 'blond', 'Pearl White': 'blond',
    'A33': 'rot', 'A530': 'rot', 'A99J': 'rot',
    'Silver': 'silber', 'Grey': 'silber',
    '1T-613': 'balayage', '2T-14': 'balayage', '2T-613': 'balayage',
    '2T-8': 'balayage', '2T-Silver': 'balayage', '2T18': 'balayage',
    '3T-613': 'balayage', '4T-613': 'balayage', '5T-18': 'balayage',
    '5T-613': 'balayage', '5T-Silver': 'balayage', 'Bergen Blond': 'balayage',
    'Natural-Grey': 'balayage', 'Norwegiant-613': 'balayage',
    '4-27T24': 'gestraehnt', '5P-18A': 'gestraehnt', '5P-Silver': 'gestraehnt',
    'Blond Ombre': 'gestraehnt', 'Dubai': 'gestraehnt',
    'Mocha Melt': 'gestraehnt', 'Viking Blond': 'gestraehnt'
  };

  var CATEGORY_ORDER = ['alle','schwarz','braun','blond','rot','silber','balayage','gestraehnt'];
  var CATEGORY_LABELS = {
    'alle': 'Alle', 'schwarz': 'Schwarz', 'braun': 'Braun', 'blond': 'Blond',
    'rot': 'Rot/Kupfer', 'silber': 'Silber', 'balayage': 'Balayage', 'gestraehnt': 'Gestr\u00e4hnt'
  };

  /* Label text -> filter key reverse lookup (fallback if data-attr is lost) */
  var LABEL_TO_KEY = {};
  for (var lk in CATEGORY_LABELS) {
    if (CATEGORY_LABELS.hasOwnProperty(lk)) {
      LABEL_TO_KEY[CATEGORY_LABELS[lk].toUpperCase()] = lk;
    }
  }

  var currentFilter = 'alle';
  var isPatching = false; /* prevent observer loop during our own patches */

  /* =============================================
   * CDN ASSET URL BUILDER
   * ============================================= */
  var cdnBase = '';

  function getCdnBase() {
    if (cdnBase) return cdnBase;
    if (window.CC_ASSET_BASE) { cdnBase = window.CC_ASSET_BASE; return cdnBase; }
    var els = document.querySelectorAll('link[href*="cdn.shopify.com"][href*="/assets/"], script[src*="cdn.shopify.com"][src*="/assets/"]');
    for (var i = 0; i < els.length; i++) {
      var url = els[i].href || els[i].src;
      var idx = url.indexOf('/assets/');
      if (idx > -1) { cdnBase = url.substring(0, idx + 8); return cdnBase; }
    }
    var imgs = document.querySelectorAll('img[src*="cdn.shopify.com"][src*="/assets/"]');
    for (var i = 0; i < imgs.length; i++) {
      var idx2 = imgs[i].src.indexOf('/assets/');
      if (idx2 > -1) { cdnBase = imgs[i].src.substring(0, idx2 + 8); return cdnBase; }
    }
    return '';
  }

  function getAssetUrl(filename) {
    var base = getCdnBase();
    if (base) return base + filename;
    return '/cdn/shop/assets/' + filename;
  }

  function getCurrentProductType() {
    var path = window.location.pathname;
    if (path.indexOf('tressen') > -1) return 'tressen';
    if (path.indexOf('tape') > -1) return 'tape';
    if (path.indexOf('bonding') > -1) return 'bonding';
    if (path.indexOf('clip-in') > -1) return 'clip-in';
    return null;
  }

  /* =============================================
   * APPLY FILTER — pure DOM operation, no re-rendering
   * ============================================= */
  function applyFilter(filterKey) {
    currentFilter = filterKey;

    var grid = document.querySelector('.hv-sw-grid');
    if (grid) {
      var btns = grid.querySelectorAll('button[data-val]');
      for (var k = 0; k < btns.length; k++) {
        var code = btns[k].getAttribute('data-val');
        /* Always compute category fresh (don't rely on data-attr) */
        var cat = COLOR_CATEGORIES[code] || btns[k].getAttribute('data-cc-category') || 'other';
        btns[k].style.display = (filterKey === 'alle' || cat === filterKey) ? '' : 'none';
      }
    }

    /* Sync pill active state */
    var allPills = document.querySelectorAll('.cc-cat-pill');
    for (var p = 0; p < allPills.length; p++) {
      var pillKey = allPills[p].getAttribute('data-cc-filter');
      if (!pillKey) {
        /* Fallback: derive key from text content */
        var txt = (allPills[p].textContent || '').trim().toUpperCase();
        pillKey = LABEL_TO_KEY[txt] || '';
        if (pillKey) allPills[p].setAttribute('data-cc-filter', pillKey);
      }
      if (pillKey === filterKey) {
        allPills[p].classList.add('active');
      } else {
        allPills[p].classList.remove('active');
      }
    }
  }

  /* =============================================
   * GLOBAL CLICK DELEGATION — attached ONCE to document
   * Works even after any re-render, for any pill
   * ============================================= */
  function setupGlobalClickDelegation() {
    if (window.__ccPillDelegation) return;
    window.__ccPillDelegation = true;

    var handler = function(e) {
      /* Walk up to find any .cc-cat-pill */
      var target = e.target;
      var pill = null;
      while (target && target !== document) {
        if (target.classList && target.classList.contains('cc-cat-pill')) {
          pill = target;
          break;
        }
        target = target.parentNode;
      }
      if (!pill) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      /* Get filter key — from attribute OR from text fallback */
      var filterKey = pill.getAttribute('data-cc-filter');
      if (!filterKey) {
        var txt = (pill.textContent || '').trim().toUpperCase();
        filterKey = LABEL_TO_KEY[txt];
      }
      if (!filterKey) return;

      applyFilter(filterKey);
    };

    /* Attach to BOTH click and pointerdown for maximum coverage on mobile */
    document.addEventListener('click', handler, true);
    document.addEventListener('touchend', function(e) {
      var target = e.target;
      var pill = null;
      while (target && target !== document) {
        if (target.classList && target.classList.contains('cc-cat-pill')) {
          pill = target;
          break;
        }
        target = target.parentNode;
      }
      if (pill) {
        e.preventDefault();
        handler(e);
      }
    }, true);
  }

  /* =============================================
   * ADD STYLES
   * ============================================= */
  function addStyles() {
    var oldStyle = document.getElementById('cc-swatch-styles');
    if (oldStyle) oldStyle.remove();

    var css = ''
      + '.cc-cat-filter,'
      + '.hv-ext .cc-cat-filter,'
      + '.hv-opt .cc-cat-filter{'
        + 'margin:0 0 20px!important;'
        + 'display:flex!important;'
        + 'flex-wrap:wrap!important;'
        + 'gap:8px!important;'
        + 'padding:4px 0!important'
      + '}'

      + '.cc-cat-pill,'
      + 'button.cc-cat-pill,'
      + '.hv-ext .cc-cat-pill,'
      + '.hv-opt .cc-cat-pill,'
      + '.cc-cat-filter button.cc-cat-pill,'
      + '.cc-cat-filter .cc-cat-pill{'
        + 'padding:11px 18px!important;'
        + 'font-size:12px!important;'
        + 'font-weight:700!important;'
        + 'letter-spacing:0.7px!important;'
        + 'text-transform:uppercase!important;'
        + 'color:#555!important;'
        + 'background:#fff!important;'
        + 'border:1.5px solid #ece6dc!important;'
        + 'border-radius:999px!important;'
        + 'cursor:pointer!important;'
        + 'transition:all 0.2s ease!important;'
        + 'font-family:inherit!important;'
        + 'white-space:nowrap!important;'
        + 'outline:none!important;'
        + 'position:relative!important;'
        + 'line-height:1!important;'
        + 'min-height:auto!important;'
        + 'min-width:auto!important;'
        + 'width:auto!important;'
        + 'height:auto!important;'
        + 'box-sizing:border-box!important;'
        + 'user-select:none!important;'
        + '-webkit-user-select:none!important;'
        + '-webkit-tap-highlight-color:transparent!important;'
        + 'touch-action:manipulation!important;'
        + 'pointer-events:auto!important'
      + '}'

      + '.cc-cat-pill:hover,'
      + 'button.cc-cat-pill:hover,'
      + '.cc-cat-filter .cc-cat-pill:hover{'
        + 'color:#b99968!important;'
        + 'border-color:#b99968!important;'
        + 'background:#fdfbf7!important;'
        + 'transform:translateY(-1px)!important;'
        + 'box-shadow:0 3px 10px rgba(185,153,104,0.15)!important'
      + '}'

      + '.cc-cat-pill.active,'
      + 'button.cc-cat-pill.active,'
      + '.cc-cat-filter .cc-cat-pill.active{'
        + 'color:#fff!important;'
        + 'background:#1a1a1a!important;'
        + 'border-color:#1a1a1a!important;'
        + 'box-shadow:0 3px 12px rgba(0,0,0,0.2)!important'
      + '}'
      + '.cc-cat-pill.active::after,'
      + '.cc-cat-filter .cc-cat-pill.active::after{'
        + 'content:""!important;'
        + 'position:absolute!important;'
        + 'bottom:-6px!important;'
        + 'left:50%!important;'
        + 'transform:translateX(-50%)!important;'
        + 'width:4px!important;'
        + 'height:4px!important;'
        + 'background:#b99968!important;'
        + 'border-radius:50%!important;'
        + 'box-shadow:0 0 0 3px rgba(185,153,104,0.22)!important;'
        + 'display:block!important'
      + '}'

      + '.hv-sw-cats{display:none!important}'

      + '.hv-sw-grid{display:flex!important;flex-wrap:wrap!important;gap:10px!important;padding:4px 0!important}'
      + '.hv-sw-grid button[data-val]{flex-shrink:0;position:relative}'
      + '.hv-sw-grid button.hv-sw--on{border:2.5px solid #b99968!important;box-shadow:0 0 0 2px rgba(185,153,104,0.25)!important;transform:scale(1.08)}'
      + '.hv-sw-grid button[data-val]:not(.hv-sw--on){border:2px solid #e5e0da!important;box-shadow:none!important}'
      + '.hv-sw-grid button[data-val]:hover:not(.hv-sw--on){border-color:#c4b9a8!important;transform:scale(1.05)}'

      + '.cc-farbe-name{color:#b99968;font-weight:600}'
      + '.cc-farbe-code{color:#999;font-weight:400;font-size:12px;margin-left:3px}'

      + '@media(max-width:749px){'
        + '.cc-cat-filter,.hv-ext .cc-cat-filter{gap:6px!important;margin:0 0 16px!important}'
        + '.cc-cat-pill,button.cc-cat-pill,.cc-cat-filter .cc-cat-pill{padding:9px 14px!important;font-size:11px!important;letter-spacing:0.5px!important}'

        + '.hv-sw-grid{gap:7px!important;padding:2px 0!important}'
        + '.hv-sw-grid button[data-val],.hv-sw-grid button.hv-sw{'
          + 'width:38px!important;height:38px!important;min-width:38px!important;min-height:38px!important'
        + '}'

        + '.hv-lbl{font-size:13px!important}'
        + '.cc-farbe-code{font-size:11px}'
        + '.hv-pill{padding:8px 16px!important;font-size:13px!important}'
        + '.hv-buy{padding:14px!important;font-size:14px!important;letter-spacing:1px!important}'
        + '.hv-acc summary{font-size:13px!important}'
        + '.hv-price-row{font-size:22px!important}'
        + '.hv-title{font-size:20px!important;line-height:1.3!important}'
        + '.hv-bens{gap:6px!important}'
        + '.hv-bens span{font-size:11px!important}'
        + '.hv-ext{padding:0 4px!important}'
        + 'media-gallery{width:100%!important}'
        + 'slideshow-component{width:100%!important}'
        + '.product-media-container{width:100%!important}'
      + '}'

      + '@media(max-width:374px){'
        + '.cc-cat-filter{gap:5px!important;margin:0 0 14px!important}'
        + '.cc-cat-pill,button.cc-cat-pill{padding:8px 12px!important;font-size:10px!important;letter-spacing:0.3px!important}'
        + '.hv-sw-grid{gap:5px!important}'
        + '.hv-sw-grid button[data-val],.hv-sw-grid button.hv-sw{'
          + 'width:34px!important;height:34px!important;min-width:34px!important;min-height:34px!important'
        + '}'
      + '}';

    var styleEl = document.createElement('style');
    styleEl.id = 'cc-swatch-styles';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  /* =============================================
   * INJECT COLOR IMAGES INTO SWATCHES
   * ============================================= */
  function injectSwatchImages() {
    var grid = document.querySelector('.hv-sw-grid');
    if (!grid) return;

    var isMobile = window.innerWidth < 750;
    var size = isMobile ? '38px' : '48px';

    var buttons = grid.querySelectorAll('button[data-val]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var colorCode = btn.getAttribute('data-val');

      var cat = COLOR_CATEGORIES[colorCode];
      if (cat) btn.setAttribute('data-cc-category', cat);

      if (btn.getAttribute('data-cc-patched')) continue;

      var assetFile = COLOR_ASSETS[colorCode];
      if (!assetFile) continue;

      var url = getAssetUrl(assetFile);
      btn.style.backgroundImage = 'url("' + url + '")';
      btn.style.backgroundSize = 'cover';
      btn.style.backgroundPosition = 'center';
      btn.style.width = size;
      btn.style.height = size;
      btn.style.borderRadius = '50%';
      btn.style.padding = '0';
      btn.style.overflow = 'hidden';
      btn.style.cursor = 'pointer';
      btn.style.transition = 'all 0.2s ease';
      btn.style.minWidth = size;
      btn.style.minHeight = size;

      var testImg = new Image();
      testImg.onload = (function(b) { return function() {
        var ch = b.children;
        for (var j = 0; j < ch.length; j++) { ch[j].style.opacity = '0'; }
      }; })(btn);
      testImg.onerror = (function(b) { return function() {
        b.style.backgroundImage = 'none';
      }; })(btn);
      testImg.src = url;

      btn.title = (COLOR_NAMES[colorCode] || colorCode) + ' (' + colorCode + ')';
      btn.setAttribute('data-cc-patched', '1');
    }
  }

  /* =============================================
   * INJECT CATEGORY FILTER
   * ============================================= */
  function injectCategoryFilter() {
    var grid = document.querySelector('.hv-sw-grid');
    if (!grid) return;
    var parent = grid.closest('.hv-opt');
    if (!parent) return;

    /* If filter already exists and has all 8 pills with correct attributes, skip */
    var existing = parent.querySelector('.cc-cat-filter');
    if (existing) {
      var existingPills = existing.querySelectorAll('.cc-cat-pill[data-cc-filter]');
      if (existingPills.length === CATEGORY_ORDER.length) {
        /* Just sync active state */
        for (var e = 0; e < existingPills.length; e++) {
          var k = existingPills[e].getAttribute('data-cc-filter');
          if (k === currentFilter) existingPills[e].classList.add('active');
          else existingPills[e].classList.remove('active');
        }
        return;
      }
      /* Otherwise rebuild */
      existing.remove();
    }

    var filterDiv = document.createElement('div');
    filterDiv.className = 'cc-cat-filter';

    for (var i = 0; i < CATEGORY_ORDER.length; i++) {
      var key = CATEGORY_ORDER[i];
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'cc-cat-pill' + (key === currentFilter ? ' active' : '');
      pill.textContent = CATEGORY_LABELS[key];
      pill.setAttribute('data-cc-filter', key);
      filterDiv.appendChild(pill);
    }

    parent.insertBefore(filterDiv, grid);
  }

  /* =============================================
   * FIX FARBE LABEL
   * ============================================= */
  function hookFarbeLabelUpdate() {
    var grid = document.querySelector('.hv-sw-grid');
    if (!grid) return;

    var labelSpan = document.getElementById('hv-v0');
    if (!labelSpan) return;

    function updateLabel(colorCode) {
      var name = COLOR_NAMES[colorCode] || colorCode;
      if (name !== colorCode) {
        labelSpan.innerHTML = '<span class="cc-farbe-name">' + name + '</span><span class="cc-farbe-code">(' + colorCode + ')</span>';
      } else {
        labelSpan.innerHTML = '<span class="cc-farbe-name">' + colorCode + '</span>';
      }
    }

    var activeBtn = grid.querySelector('button.hv-sw--on');
    if (activeBtn) updateLabel(activeBtn.getAttribute('data-val'));

    var buttons = grid.querySelectorAll('button[data-val]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('data-cc-label-hooked')) continue;
      buttons[i].addEventListener('click', function() {
        updateLabel(this.getAttribute('data-val'));
      });
      buttons[i].setAttribute('data-cc-label-hooked', '1');
    }
  }

  /* =============================================
   * GALLERY SYNC FUNCTIONS
   * ============================================= */
  function normalize(str) {
    return str.replace(/[\s._\-]/g, '').toLowerCase();
  }

  function buildColorSlideMap() {
    var ss = document.querySelector('slideshow-component');
    if (!ss || !ss.slides) return {};

    var slides = ss.slides;
    var grid = document.querySelector('.hv-sw-grid');
    if (!grid) return {};

    var btns = grid.querySelectorAll('button[data-val]');
    var normLookup = {};
    for (var c = 0; c < btns.length; c++) {
      var val = btns[c].getAttribute('data-val');
      normLookup[normalize(val)] = val;
    }

    var map = {};
    for (var s = 0; s < slides.length; s++) {
      var img = slides[s].querySelector('img');
      if (!img) continue;
      var src = img.src || img.getAttribute('data-src') || '';
      var filePart = src.split('/files/').pop();
      if (!filePart) continue;
      filePart = filePart.split('?')[0];
      var parts = filePart.split('_-_');
      if (parts.length >= 2) {
        var rawCode = parts[1];
        var normCode = normalize(rawCode);
        if (normLookup[normCode] && !map[normLookup[normCode]]) {
          map[normLookup[normCode]] = s;
        }
      }
    }
    return map;
  }

  function hookGalleryNavigation() {
    var grid = document.querySelector('.hv-sw-grid');
    var ss = document.querySelector('slideshow-component');
    if (!grid || !ss) return;

    var colorSlideMap = buildColorSlideMap();

    var buttons = grid.querySelectorAll('button[data-val]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('data-cc-gallery-hooked')) continue;
      buttons[i].addEventListener('click', (function(slideMap, slideshow) {
        return function() {
          var code = this.getAttribute('data-val');
          var slideIdx = slideMap[code];
          if (slideIdx !== undefined && typeof slideshow.select === 'function') {
            slideshow.select(slideIdx);
          }
        };
      })(colorSlideMap, ss));
      buttons[i].setAttribute('data-cc-gallery-hooked', '1');
    }
  }

  function hookGalleryToSwatchSync() {
    var ss = document.querySelector('slideshow-component');
    var grid = document.querySelector('.hv-sw-grid');
    if (!ss || !ss.slides || !grid) return;
    if (window.__ccGallerySync) return;
    window.__ccGallerySync = true;

    var slides = ss.slides;

    var btns = grid.querySelectorAll('button[data-val]');
    var normLookup = {};
    for (var c = 0; c < btns.length; c++) {
      var val = btns[c].getAttribute('data-val');
      normLookup[normalize(val)] = val;
    }

    var slideToColor = {};
    for (var s = 0; s < slides.length; s++) {
      var img = slides[s].querySelector('img');
      if (!img) continue;
      var src = img.src || img.getAttribute('data-src') || '';
      var filePart = src.split('/files/').pop();
      if (!filePart) continue;
      filePart = filePart.split('?')[0];
      var parts = filePart.split('_-_');
      if (parts.length >= 2) {
        var normCode = normalize(parts[1]);
        if (normLookup[normCode]) {
          slideToColor[s] = normLookup[normCode];
        }
      }
    }

    var lastSlide = ss.current;
    var lastColor = slideToColor[lastSlide] || '';
    var syncing = false;

    grid.addEventListener('click', function(e) {
      if (e.target.closest('button[data-val]')) {
        syncing = true;
        setTimeout(function() { syncing = false; }, 800);
      }
    });

    setInterval(function() {
      if (syncing) return;
      var cur = ss.current;
      if (cur === lastSlide) return;
      lastSlide = cur;

      var colorCode = slideToColor[cur];
      if (!colorCode || colorCode === lastColor) return;
      lastColor = colorCode;

      var btn = grid.querySelector('button[data-val="' + colorCode.replace(/"/g, '\\"') + '"]');
      if (btn) {
        syncing = true;
        btn.click();
        setTimeout(function() { syncing = false; }, 800);
      }
    }, 300);
  }

  function removeHairTypeSwitcher() {
    var el = document.querySelector('.cc-hair-switcher');
    if (el) el.remove();
  }

  function preselectColorFromURL() {
    var params = new URLSearchParams(window.location.search);
    var colorParam = params.get('color');
    if (!colorParam) return;

    var grid = document.querySelector('.hv-sw-grid');
    if (!grid) return;

    var buttons = grid.querySelectorAll('button[data-val]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('data-val') === colorParam) {
        buttons[i].click();
        break;
      }
    }
  }

  /* =============================================
   * RUN ALL PATCHES (idempotent, with loop protection)
   * ============================================= */
  function runPatches() {
    if (isPatching) return;
    isPatching = true;

    try {
      var grid = document.querySelector('.hv-sw-grid');
      if (!grid) return;

      addStyles();
      injectSwatchImages();
      injectCategoryFilter();
      hookFarbeLabelUpdate();
      removeHairTypeSwitcher();
      hookGalleryNavigation();

      /* Re-apply current filter state */
      applyFilter(currentFilter);
    } finally {
      /* Release lock after a tick to let DOM settle */
      setTimeout(function() { isPatching = false; }, 100);
    }
  }

  /* =============================================
   * MUTATION OBSERVER — more conservative, skips during our own patches
   * ============================================= */
  function startMutationObserver() {
    var debounceTimer = null;

    var observer = new MutationObserver(function(mutations) {
      /* Skip if we're currently patching to avoid loops */
      if (isPatching) return;

      var needsRepatch = false;

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        /* Ignore mutations on pills themselves (e.g. our class changes) */
        if (m.target && m.target.classList &&
            (m.target.classList.contains('cc-cat-pill') || m.target.classList.contains('cc-cat-filter'))) {
          continue;
        }

        for (var j = 0; j < m.removedNodes.length; j++) {
          var node = m.removedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.classList && (node.classList.contains('cc-cat-filter') || node.classList.contains('hv-sw-grid'))) {
            needsRepatch = true;
            break;
          }
          if (node.querySelector && (node.querySelector('.cc-cat-filter') || node.querySelector('.hv-sw-grid'))) {
            needsRepatch = true;
            break;
          }
        }

        for (var k = 0; k < m.addedNodes.length; k++) {
          var added = m.addedNodes[k];
          if (added.nodeType !== 1) continue;
          if (added.classList && added.classList.contains('hv-sw-grid')) {
            needsRepatch = true;
            break;
          }
          if (added.querySelector && added.querySelector('.hv-sw-grid')) {
            needsRepatch = true;
            break;
          }
        }

        if (needsRepatch) break;
      }

      /* Check if filter is completely missing */
      if (!needsRepatch && !document.querySelector('.cc-cat-filter') && document.querySelector('.hv-sw-grid')) {
        needsRepatch = true;
      }

      if (needsRepatch) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          runPatches();
        }, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /* =============================================
   * INITIALIZE
   * ============================================= */
  function init() {
    if (!getCurrentProductType()) return;

    /* Setup delegation IMMEDIATELY */
    setupGlobalClickDelegation();

    var attempts = 0;
    var interval = setInterval(function() {
      attempts++;
      var grid = document.querySelector('.hv-sw-grid');

      if (grid || attempts > 50) {
        clearInterval(interval);
        if (grid) {
          runPatches();

          setTimeout(function() {
            hookGalleryToSwatchSync();
            preselectColorFromURL();
          }, 600);

          setTimeout(function() {
            startMutationObserver();
          }, 300);

          /* Safety net — only repatch if something's actually broken */
          var safetyRuns = 0;
          var safetyInterval = setInterval(function() {
            safetyRuns++;
            var needsFix = !document.querySelector('.cc-cat-filter') ||
                           document.querySelectorAll('.cc-cat-pill').length !== CATEGORY_ORDER.length;
            if (needsFix) runPatches();
            if (safetyRuns >= 5) clearInterval(safetyInterval);
          }, 2000);
        }
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();